import { useMemo, useCallback } from 'react'
import { DatePrice } from './date-price'
import { compareDates } from 'src/utils/date'

type DailyPricesProps = {
  dailyPrices: { day: Date; price: number }[]
  onDayPriceChange: (updatedDailyPrices: { day: Date; price: number }[]) => void
}
export const DailyPrices = (props: DailyPricesProps) => {
  const { dailyPrices, onDayPriceChange } = props

  const totalCheckAmount = useMemo(() => {
    return dailyPrices?.reduce((previous, { price }) => previous + price, 0)
  }, [dailyPrices])

  const onDayPriceChageHandler = useCallback(
    (day: Date, price: number) => {
      const updatedDailyPrices = dailyPrices.map((item) => ({
        day: item.day,
        price: compareDates(day, item.day) === 0 ? price : item.price,
      }))

      onDayPriceChange(updatedDailyPrices)
    },
    [dailyPrices],
  )

  const items = useMemo(() => {
    const rows: JSX.Element[] = []
    dailyPrices.forEach(({ day, price }, index) => {
      rows.push(<DatePrice key={index} date={day} amount={price} onChange={(amount: number) => onDayPriceChageHandler(day, amount)} />)
    })
    return rows
  }, [dailyPrices, totalCheckAmount])

  return <div>{items}</div>
}
